<template>
  <el-scrollbar class="components-attr-edit">
    <p class="page-title fontBold">项目样式</p>
    <div class="attr-item-edit-wrapper">
      <p class="attr-item-title">背景颜色：</p>
      <div class="attr-item-edit-input no-top">
        <el-color-picker size="mini" :show-alpha="true"
                         v-model="projectData.backgroundColor"></el-color-picker>
      </div>
    </div>
    <div class="attr-item-edit-wrapper">
      <p class="attr-item-title">背景图片：</p>
      <div class="attr-item-edit-input">
        <imageSelect :url.sync="projectData.backgroundImage" />
      </div>
    </div>
    <div class="attr-item-edit-wrapper">
      <p class="attr-item-title">背景图片样式：</p>
      <div class="attr-item-edit-input" style="display:flex;flex-direction: column;justify-content: flex-start;align-items: flex-start;">
        <el-radio style="margin-bottom:5px;" v-model="projectData.backgroundImageStyle" label="1">高度铺满，宽度自适应</el-radio>
        <el-radio v-model="projectData.backgroundImageStyle" label="2">宽高均铺满</el-radio>
      </div>
    </div>
    <div class="attr-item-edit-wrapper">
      <p class="attr-item-title">背景音乐：</p>
      <div class="attr-item-edit-input">
        <musicSelect :url.sync="projectData.backgroundMusic" />
      </div>
    </div>
    <div class="attr-item-edit-wrapper">
      <p class="attr-item-title">背景音乐自动播放：</p>
      <div class="attr-item-edit-input">
        <el-checkbox
            v-model="projectData.backgroundMusicAutoPlay"
            :true-label="1"
            :false-label="0"
          ></el-checkbox>
      </div>
    </div>
  </el-scrollbar>
</template>

<script>
	import {mapState, mapGetters} from 'vuex'
	import imageSelect from '@client/components/image-select'
	import musicSelect from '@client/components/music-select'
	export default {
		components: {
			imageSelect,
      musicSelect
		},
		computed: {
			...mapState({
				activePageUUID: state => state.editor.activePageUUID,
				activeElementUUID: state => state.editor.activeElementUUID
			}),
			...mapGetters([
        'projectData',
				'currentPageIndex',
				'activeElementIndex',
				'activeElement',
        'activePage'
			])
		},
	}
</script>

<style lang="scss" scoped>
  .components-attr-edit {
    height: 100%;
  }

  .components-attr-animate-edit {
    position: relative;
  }

  .attr-title {
    font-weight: bold;
  }
  .attr-item-edit-wrapper {
    padding-left: 18px;
    display: flex;
    width: 100%;
    text-align: center;
    padding-bottom: 10px;
    .attr-item-title {
      text-align: left;
      min-width: 60px;
      font-size: 12px;
    }
    .attr-item-edit-input {
      &.col-2 {
        width: 90px;
        margin-left: 10px;
      }
      &.col-1 {
        width: 250px;
      }
      &.col-3 {
        width: 60px;
        margin-left: 10px;
      }
      &.col-4 {
        width: 50px;
        margin-left: 10px;
      }
      .attr-item-edit-input-des {
        text-align: center;
        line-height: 1;
        margin-top: 2px;
        font-size: 12px;
        color: $gray;
      }
    }
  }
</style>
